<template>
  <section id="green-section">
    <h1 class="title">{{$resx('GreenScoreText')}}</h1>
    <h2 class="subtitle">Green-Points by Campings.Luxe</h2>
    <header>
      <p>{{$resx('GreenScoreHeader1Text')}}</p>
      <p>{{$resx('GreenScoreHeader2Text')}}</p>
    </header>
    <div v-if="isLoading">
      <i class="loading material-icons">cached</i>
    </div>
    <div v-else style="position:relative">
      <div class="categ" v-for="categ in greenScore.categories"  :key="categ.id">
        <header >
          <circle-progress :width="136" :value="categ.completedRatio"></circle-progress>
          <h2 :class="{'highlight' : categ.completedRatio===100}" >{{categ.name}}</h2>
        </header>
        <green-section v-for="subCateg in categ.subCategories" :key="subCateg.id" :category="subCateg" v-on:update-category="onsubCategoryUpdated"></green-section>
      </div>
      <div class="very-green-acts">
        <header>
          <h2>Very Green Acts</h2>
          <p class="desc" v-html="$resx('GreenScoreActsExplicationsText', [nbMaxActs, nbMaxChars])"></p>
        </header>
        <div class="act" v-for="(act, index) in greenScore.acts" :key="index">
          <div class="text">
            <i v-show="!act.edit">{{act.value}}</i>
            <textarea v-show="act.edit" :maxlength="nbMaxChars" v-model="act.value" required rows="8" ></textarea>
            <span v-show="act.edit" class="remaining" v-html="displayRemainingCharacters(act)"></span>
          </div>
          <div class="commands">
            <button v-show="!act.edit" class="btn btn-secondary" @click="editAct(act)">{{$resx('EditText')}}</button>
            <button class="btn btn-secondary" @click="deleteAct(index)">{{$resx('DeleteText')}}</button>
          </div>
        </div>
        <div>
          <button class="btn btn-secondary" @click="addAct" :disabled="!canAdd">{{$resx('AddText')}}</button>
          <button class="btn btn-primary" :class="{'is-loading' : isPostingActs}" :disabled="!canSubmitActs" @click="submitGreenActs">{{$resx('GreenScoreSendForValidationText')}}</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import greenSection from '../components/green/greenSection.vue'
import greenServices from '../services/greenServices'
import Category from '../models/green/category'
import circleProgress from '../components/circleProgress.vue'

require('../assets/greenScore.less')

export default {
  data () {
    return {
      isLoading: false,
      greenScore: {
        isGreen: false,
        categories: null,
        acts: null
      },
      isPostingActs: false,
      nbMaxActs: 10,
      nbMaxChars: 800,
      actsUpdate: false
    }
  },
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    },
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },
    // autoriser ou non l'envoie des very green acts
    canSubmitActs () {
      var canSubmit = this.actsUpdate && (this.greenScore.acts != null && this.greenScore.acts.length > 0)
      if (canSubmit) {
        this.greenScore.acts.forEach(function (act) {
          if (act.value.trim().length < 50) {
            canSubmit = false
          }
        })
      }
      // console.log('canSubmit', canSubmit)
      return canSubmit
    },
    // ajouter un green act
    canAdd () {
      return this.greenScore.acts === null || this.greenScore.acts.length < this.nbMaxActs
    }
  },
  watch: {
    // détecter un changement de camping
    currentCampingId: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadGreenScore()
      }
    }
  },
  methods: {
    // charge la liste des semaines
    async loadGreenScore () {
      if (!this.partner.currentCamping.isGreen) {
        this.$router.push('home')
      }
      this.isLoading = true
      try {
        var model = await greenServices.load(this.currentCampingId)
        this.greenScore.isGreen = model.isGreen
        this.greenScore.categories = []
        this.greenScore.acts = []
        const self = this
        model.acts.forEach((act) => {
          self.greenScore.acts.push({ value: act, edit: false })
        })
        model.categories.forEach((categ) => {
          self.greenScore.categories.push(new Category(categ))
        })
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      } finally {
        this.isLoading = false
      }
    },
    // mise a jour d'une sous-categorie
    onsubCategoryUpdated (updatedCateg) {
      this.greenScore.categories.forEach((categ) => {
        categ.subCategories.forEach((subCateg) => {
          if (subCateg.id === updatedCateg.id) {
            subCateg.items = updatedCateg.items
            return 0
          }
        })
      })
    },
    // poster des textes pour VeryGreenActs
    async submitGreenActs () {
      try {
        this.isPostingActs = true
        var msg = await greenServices.submitGreenActs(this.currentCampingId, this.greenScore.acts.map(x => x.value))
        this.$store.commit('app/showSnack', { type: 'success', message: msg })
        this.actsUpdate = false
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      } finally {
        this.isPostingActs = false
      }
    },
    // suppression d'un very green act
    deleteAct (index) {
      this.actsUpdate = true
      // console.log(index)
      if (index > -1 && index < this.greenScore.acts.length) {
        this.greenScore.acts.splice(index, 1)
      } else {
        this.$store.commit('app/showSnack', { type: 'error', message: 'error' })
      }
    },
    // ajout dun very green act
    addAct () {
      this.actsUpdate = true
      // on desactive l'edition des autres
      this.greenScore.acts.forEach((item) => {
        item.edit = false
      })
      // on ajoute le nouveau editable
      this.greenScore.acts.push({ value: '', edit: true })
    },
    // rendre editable un item
    editAct (act) {
      this.actsUpdate = true
      // on desactive l'edition des autres
      this.greenScore.acts.forEach((item) => {
        item.edit = false
      })
      act.edit = true
    },
    // afficher le nb de caractères restants
    displayRemainingCharacters (act) {
      var nb = this.nbMaxChars - act.value.length
      return this.$resx('RemainingCharactersText', [nb])
    }
  },
  components:
  {
    'green-section': greenSection,
    'circle-progress': circleProgress
  },
  async mounted () {
    this.$store.commit('app/setPage', 'greenscore')
    await this.loadGreenScore()
  }
}
</script>
